// extracted by mini-css-extract-plugin
export var dividerLine = "_7c-3";
export var itemImage = "_7c-9";
export var lightDivider = "_7c-4";
export var modalContent = "_7c-5";
export var modalContentCompact = "_7c-6";
export var productCard = "_7c-a";
export var productImage = "_7c-b";
export var productImageCompact = "_7c-7";
export var productImagePlaceholder = "_7c-c";
export var productImagePlaceholderCompact = "_7c-8";
export var progressBarBackground = "_7c-1";
export var progressBarContainer = "_7c-0";
export var progressBarFill = "_7c-2";